import React from "react";
import "./CvantoAIVisual.scss";

// Pure CSS/SVG concentric-dot visual — no canvas/WebGL, per the redesign
// brief's explicit performance/stability priority. `state` only switches
// CSS classes; all motion is driven by CSS keyframes/transitions so it
// stays cheap on low-end mobile.
const RING_RADII = [0, 7, 14, 21, 28];

const buildDots = () => {
  const dots = [];

  RING_RADII.forEach((radius, ringIndex) => {
    if (radius === 0) {
      dots.push({ x: 0, y: 0, ringIndex, size: 3.6 });
      return;
    }

    const count = ringIndex * 6;
    for (let i = 0; i < count; i += 1) {
      const angle = (i / count) * Math.PI * 2;
      dots.push({
        x: Math.cos(angle) * radius,
        y: Math.sin(angle) * radius,
        ringIndex,
        size: Math.max(1.6, 3.6 - ringIndex * 0.5),
      });
    }
  });

  return dots;
};

const DOTS = buildDots();

const CvantoAIVisual = ({ state = "idle", onTap, label, decorative = false }) => {
  // `decorative` renders the same visual as a non-interactive, hidden-from-AT
  // element (used as an illustration, e.g. the Cvanto AI chat's empty state).
  const Root = decorative ? "div" : "button";
  const rootProps = decorative
    ? { "aria-hidden": "true" }
    : { type: "button", onClick: onTap, "aria-label": label || "Cvanto Search" };

  return (
    <Root className={`cvanto-orb cvanto-orb--${state}`} {...rootProps}>
      <span className="cvanto-orb__glow" aria-hidden="true" />

      <svg
        className="cvanto-orb__field"
        viewBox="-32 -32 64 64"
        aria-hidden="true"
      >
        {DOTS.map((dot, idx) => (
          <circle
            key={idx}
            className="cvanto-orb__dot"
            cx={dot.x}
            cy={dot.y}
            r={dot.size / 2}
            style={{
              "--ring": dot.ringIndex,
              "--delay": `${(idx % 12) * 40}ms`,
            }}
          />
        ))}
      </svg>
    </Root>
  );
};

export default CvantoAIVisual;
